import React, {Component} from 'react';
import './Predictor.css';

import AvatarShell from './AvatarShell.js';
import Results from './Results';

import AvatarFather from './avatars/Father';
import AvatarMaternalGrandfather from './avatars/MaternalGrandfather';
import AvatarMaternalGrandmother from './avatars/MaternalGrandmother';
import AvatarMother from './avatars/Mother';
import AvatarPaternalGrandfather from './avatars/PaternalGrandfather';
import AvatarPaternalGrandmother from './avatars/PaternalGrandmother';

import ColorToHex from './ColorToHex';
import ShadeColorToHex from './ShadeColorToHex';

import hr from './hr.svg';

class Predictor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      env: process.env.NODE_ENV,

      results: {},

      paternalGrandmother: 0,
      paternalGrandfather: 0,

      maternalGrandmother: 0,
      maternalGrandfather: 0,

      father: 0,
      mother: 0,
    }

    this.getResults = this.getResults.bind(this);
    this.handleAvatarClick = this.handleAvatarClick.bind(this);
  };

  componentDidMount() {
    this.getResults();
  }

  getResults() {
    var formData = new FormData();
    formData.append('maternal_grandmother', this.decodeOption(this.state.maternalGrandmother));
    formData.append('maternal_grandfather', this.decodeOption(this.state.maternalGrandfather));
    formData.append('paternal_grandmother', this.decodeOption(this.state.paternalGrandmother));
    formData.append('paternal_grandfather', this.decodeOption(this.state.paternalGrandfather));
    formData.append('mother', this.decodeOption(this.state.mother));
    formData.append('father', this.decodeOption(this.state.father));

    fetch(`https://com-pregnantchicken-predictor-hair-api.fly.dev/app/predictor/hair/api`, {
      method: 'POST',
      // headers: new Headers({
      //   'Authentication': process.env.NEXT_PUBLIC_API_KEY,
      // }),
      body: formData,
    })
    .then((res) => res.json())
    .then((data) => {
      console.log(data);
      this.setState({
        results: data.results,
      });
    })
  }

  handleAvatarClick(person) {
    console.log(person);
    console.log(this.state[person]);
    this.setState({
      [person]: this.incrementOption(this.state[person])
    }, function() {
      console.log(this.state[person]);
      this.getResults();
    })
  }

  incrementOption(current) {
    if (current === 5) {
      return 0;
    } else {
      return current+1;
    }
  }

  decodeOption(int) {
    switch (int) {
      case 0:
        return '';
      case 1:
        return 'black';
      case 2:
        return 'brown';
      case 3:
        return 'red';
      case 4:
        return 'strawberry blonde';
      case 5:
        return 'blonde';
    }
  }

  render() {
    return (
      <div className="Predictor">
        <h2>Hair Color Predictor</h2>
        <img className="hr large" src={hr} alt="" />
        <h3>Click on each character to select the color of their hair</h3>

        <div className="Predictor-avatars-shell">
          <AvatarShell
            personID="paternalGrandmother"
            personLabelSide="Paternal"
            personLabel="Grandmother"
            handleAvatarClick={this.handleAvatarClick}
            colorName={this.decodeOption(this.state.paternalGrandmother)}
            avatar={
              <AvatarPaternalGrandmother
                colorHex={ColorToHex(this.decodeOption(this.state.paternalGrandmother))}
                shadeColorHex={ShadeColorToHex(this.decodeOption(this.state.paternalGrandmother))}
              />
            }
          />
          <AvatarShell
            personID="paternalGrandfather"
            personLabelSide="Paternal"
            personLabel="Grandfather"
            handleAvatarClick={this.handleAvatarClick}
            colorName={this.decodeOption(this.state.paternalGrandfather)}
            avatar={
              <AvatarPaternalGrandfather
                colorHex={ColorToHex(this.decodeOption(this.state.paternalGrandfather))}
                shadeColorHex={ShadeColorToHex(this.decodeOption(this.state.paternalGrandfather))}
              />
            }
          />
        </div>

        <div className="Predictor-avatars-shell">
          <AvatarShell
            personID="maternalGrandmother"
            personLabelSide="Maternal"
            personLabel="Grandmother"
            handleAvatarClick={this.handleAvatarClick}
            colorName={this.decodeOption(this.state.maternalGrandmother)}
            avatar={
              <AvatarMaternalGrandmother
                colorHex={ColorToHex(this.decodeOption(this.state.maternalGrandmother))}
                shadeColorHex={ShadeColorToHex(this.decodeOption(this.state.maternalGrandmother))}
              />
            }
          />
          <AvatarShell
            personID="maternalGrandfather"
            personLabelSide="Maternal"
            personLabel="Grandfather"
            handleAvatarClick={this.handleAvatarClick}
            colorName={this.decodeOption(this.state.maternalGrandfather)}
            avatar={
              <AvatarMaternalGrandfather
                colorHex={ColorToHex(this.decodeOption(this.state.maternalGrandfather))}
                shadeColorHex={ShadeColorToHex(this.decodeOption(this.state.maternalGrandfather))}
              />
            }
          />
        </div>
        <div className="Predictor-avatars-shell">
          <AvatarShell
            personID="father"
            personLabel="Father"
            handleAvatarClick={this.handleAvatarClick}
            colorName={this.decodeOption(this.state.father)}
            avatar={
              <AvatarFather
                colorHex={ColorToHex(this.decodeOption(this.state.father))}
                shadeColorHex={ShadeColorToHex(this.decodeOption(this.state.father))}
              />
            }
          />
          <AvatarShell
            personID="mother"
            personLabel="Mother"
            handleAvatarClick={this.handleAvatarClick}
            colorName={this.decodeOption(this.state.mother)}
            avatar={
              <AvatarMother
                colorHex={ColorToHex(this.decodeOption(this.state.mother))}
                shadeColorHex={ShadeColorToHex(this.decodeOption(this.state.mother))}
              />
            }
          />
        </div>

        <Results
          dev={this.state.dev}
          maternalGrandmother={this.state.maternalGrandmother}
          maternalGrandfather={this.state.maternalGrandfather}
          paternalGrandmother={this.state.paternalGrandmother}
          paternalGrandfather={this.state.paternalGrandfather}
          mother={this.state.mother}
          father={this.state.father}
          results={this.state.results}
        />
      </div>
    );
  }
}

export default Predictor;
